/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import {
    AppBar,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    FormControlLabel,
    Grid,
    TextField,
    Toolbar,
} from '@material-ui/core';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import React from 'react';
import { IFormularioTipoIdentificacionVistaProps } from '../interfaces';

const FormularioTipoIdentificacionVista: React.FunctionComponent<IFormularioTipoIdentificacionVistaProps> = ({
    accionCrearEditar,
    cambiarInfoFomulario,
    cerrarFormulario,
    estadoFormulario,
    tipoIdentificacion,
    tipoFormulario,
}) => (
    <Dialog open={estadoFormulario}>
        <AppBar position="static">
            <Toolbar>
                <Grid container justifyContent="center">
                    <Texto
                        align="center"
                        color="inherit"
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'tipoIdentificacion.agregarTipoIdentificacion'
                                : 'tipoIdentificacion.modificarTipoIdentificacion'
                        }
                    />
                </Grid>
            </Toolbar>
        </AppBar>
        <DialogContent>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="tipoIdentificacion.abreviatura" display="inline" />}
                        name="Abreviatura"
                        onChange={cambiarInfoFomulario}
                        required
                        value={tipoIdentificacion.Abreviatura}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="tipoIdentificacion.nombreTipoIdentificacion" display="inline" />}
                        name="NombreTipoIdentificacion"
                        onChange={cambiarInfoFomulario}
                        required
                        value={tipoIdentificacion.DescripcionTipoIdentificacion}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={<Checkbox checked={tipoIdentificacion.Estado} onChange={cambiarInfoFomulario} />}
                        label={<Texto id="tipoIdentificacion.estadoTipoIdentificacion" display="inline" />}
                        name="EstadoTipoIdentificacion"
                    />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <div>
                <Grid container justifyContent="flex-end" spacing={2}>
                    <Grid item>
                        <Button onClick={cerrarFormulario} color="secondary" variant="contained">
                            <Texto id="boton.cancelar" />
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button onClick={accionCrearEditar} color="primary" variant="contained">
                            <Texto id="boton.guardar" />
                        </Button>
                    </Grid>
                </Grid>
            </div>
        </DialogActions>
    </Dialog>
);

export default FormularioTipoIdentificacionVista;
